import React from 'react'
import { breakpointsV2 } from 'spa/config/styled'
import { useWindowWidth } from 'spa/hooks/useWindowWidth'
import FlowStep01 from 'images/spa/flow_step_01.svg'
import FlowStep02 from 'images/spa/flow_step_02.svg'
import FlowStep03 from 'images/spa/flow_step_03.svg'
import FlowStep04 from 'images/spa/flow_step_04.svg'
import FlowStep05 from 'images/spa/flow_step_05.svg'
import styles from './ServiceFlow.module.scss'
import { FlowCard } from '../FlowCard'
import { responsiveValue } from 'spa/libs/utils/responsiveValue'

const StyledServiceFlowContainer: React.FC = () => {
  const windowWidth = useWindowWidth()
  const isTablet = breakpointsV2.mobile <= windowWidth && windowWidth < breakpointsV2.desktop

  return (
    <div className={`bg-member-background-100 ${styles.serviceFlowContainer}`}>
      <div className={`${styles.contents}`}>
        <div className={`w-full mx-auto text-center`}>
          <h2
            className={`
              text-L font-bold text-member-gray-100 pb-M
              tablet:text-3XL tablet:pb-XL
            `}
          >
            ご利用の流れ
          </h2>
          <p
            className={`
              text-S pb-XS text-member-gray-100
              tablet:text-M tablet:pb-4XL
              desktop:text-M desktop:pb-4XL
            `}
            style={ {lineHeight: '1.75'}}
          >
            会員登録からお仕事決定までの流れをご説明します。
          </p>
          <div
            className={`
              gap-XL justify-center
              ${styles.flowCardContainer}
            `}
          >
            <FlowCard
              className={styles.flowCard}
              image={FlowStep01}
              alt="ご利用の流れステップ1"
              headerText="会員登録"
              text="まずはクラウドワークス テックに会員登録しましょう。60秒で会員登録完了します。"
            />
            <FlowCard
              className={styles.flowCard}
              image={FlowStep02}
              alt="ご利用の流れステップ2"
              headerText={`経歴書\nポートフォリオを${responsiveValue(isTablet, '', '\n')}登録`}
              text="クラウドワークス テックがあなたのことを企業に推薦できるよう、職務経歴書やポートフォリオをWeb上から登録してください。"
            />
            <FlowCard
              className={styles.flowCard}
              image={FlowStep03}
              alt="ご利用の流れステップ3"
              headerText={'気になった\nお仕事に応募'}
              text="Web上から気になるお仕事に応募ができます。応募の際、スキルセットや活かせる経験などを記載いただくとクラウドワークス テックから企業に推薦しやすくなります。"
            />
            <FlowCard
              className={styles.flowCard}
              image={FlowStep04}
              alt="ご利用の流れステップ4"
              headerText={'書類審査\n面談'}
              text="書類が通過すると、企業との面談に進みます。面談にはクラウドワークス テックの弊社担当者が付き添い、3者面談を行います。"
            />
            <FlowCard
              className={styles.flowCard}
              image={FlowStep05}
              alt="ご利用の流れステップ5"
              headerText="お仕事決定"
              text="稼働後も円滑にお仕事ができるようクラウドワークス テックがフォローします。"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default StyledServiceFlowContainer
